module.exports = __webpack_public_path__ + "static/logo-d266bd1d0984c73d1b744a2ed0444dfa.png";